const isDefined = (thing) => thing !== undefined && thing !== null

export default isDefined
